/* Soulmarket — utilidades compartidas entre el listado y la ficha.
   Todo lo que se guarda (favoritos, vistos) vive en el navegador de
   cada visitante y se degrada sin romper si el storage no está. */
(function () {
  var SM = window.Soulmarket = window.Soulmarket || {};

  function leer(k, def) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : def; } catch (e) { return def; } }
  function guardar(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  var fmtNum = new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 });
  SM.num = function (v) { return fmtNum.format(v); };
  SM.precio = function (v, mon) { return (mon || 'USD') + ' ' + fmtNum.format(v); };

  /* ---- favoritos ---- */
  SM.favs = function () { return leer('sm-favs', []); };
  SM.esFav = function (h) { return SM.favs().indexOf(h) !== -1; };
  SM.toggleFav = function (h) {
    var f = SM.favs(), i = f.indexOf(h);
    if (i === -1) f.unshift(h); else f.splice(i, 1);
    guardar('sm-favs', f.slice(0, 200));
    document.dispatchEvent(new CustomEvent('sm:favs'));
    return i === -1;
  };
  SM.pintarFavs = function (raiz) {
    (raiz || document).querySelectorAll('[data-fav]').forEach(function (b) {
      var on = SM.esFav(b.dataset.fav);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var t = b.querySelector('[data-fav-txt]');
      if (t) t.textContent = on ? 'Guardado' : 'Guardar';
      b.setAttribute('aria-label', on ? 'Quitar de guardados' : 'Guardar aviso');
    });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = SM.toggleFav(b.dataset.fav);
    SM.pintarFavs();
    SM.toast(on ? 'Guardado en tus avisos' : 'Quitado de guardados');
  });

  /* ---- vistos recientemente ---- */
  SM.vistos = function () { return leer('sm-vistos', []); };
  SM.registrarVisto = function (a) {
    var v = SM.vistos().filter(function (x) { return x.h !== a.h; });
    v.unshift(a); guardar('sm-vistos', v.slice(0, 12));
  };

  /* ---- dólar MEP (para comparar precios en pesos y dólares) ---- */
  SM.dolar = function () {
    if (SM._dolar) return SM._dolar;
    var cache = leer('sm-dolar', null);
    if (cache && Date.now() - cache.t < 6 * 3600 * 1000) return (SM._dolar = Promise.resolve(cache.v));
    SM._dolar = fetch('https://dolarapi.com/v1/dolares/bolsa')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { var v = j && j.venta ? +j.venta : null; if (v) guardar('sm-dolar', { v: v, t: Date.now() }); return v; })
      .catch(function () { return cache ? cache.v : null; });
    return SM._dolar;
  };
  SM.enUSD = function (precio, mon, mep) {
    if (!precio && precio !== 0) return null;
    if (mon === 'ARS') return mep ? precio / mep : null;
    return precio;
  };
  SM.aprox = function (precio, mon, mep) {
    if (!mep || !precio) return '';
    return mon === 'ARS' ? '≈ USD ' + fmtNum.format(precio / mep) + ' al MEP' : '≈ ARS ' + fmtNum.format(precio * mep) + ' al MEP';
  };

  /* ---- fechas ---- */
  SM.dias = function (iso) {
    if (!iso) return null;
    var d = new Date(iso + 'T12:00:00');
    if (isNaN(d)) return null;
    return Math.max(0, Math.floor((Date.now() - d.getTime()) / 86400000));
  };
  SM.hace = function (iso) {
    var n = SM.dias(iso);
    if (n === null) return '';
    if (n === 0) return 'Hoy';
    if (n === 1) return 'Ayer';
    if (n < 7) return 'Hace ' + n + ' días';
    if (n < 30) { var s = Math.floor(n / 7); return 'Hace ' + s + (s === 1 ? ' semana' : ' semanas'); }
    var m = Math.floor(n / 30); return 'Hace ' + m + (m === 1 ? ' mes' : ' meses');
  };

  /* ---- aviso flotante ---- */
  SM.toast = function (txt) {
    var t = document.querySelector('.sm-toast');
    if (!t) { t = document.createElement('div'); t.className = 'sm-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = txt; t.hidden = false;
    clearTimeout(SM._tt); SM._tt = setTimeout(function () { t.hidden = true; }, 2200);
  };

  /* ---- compartir ---- */
  SM.compartir = function (titulo, url) {
    if (navigator.share) { navigator.share({ title: titulo, url: url }).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { SM.toast('Link copiado'); });
    else window.prompt('Copiá el link', url);
  };
})();
